import { z } from 'zod';

export const ForgotPasswordInputSchema = z.object({
    email: z.string().nonempty("E-mail nesmí být prázdný"),
})


export const ResetPasswordInputSchema = z.object({
    password_verify: z.string().nonempty("Heslo nesmí být prázdné"),
    password: z.string().nonempty("Heslo nesmí být prázdné").min(8, "Heslo musí mít minimálně 8 znaků").max(30, "Heslo může mít maximálně 30 znaků"),
}).superRefine(({ password, password_verify }, ctx) => {
    if (password_verify !== password) {
        ctx.addIssue({
            code: "custom",
            message: "Hesla se musí shodovat"
        })
    }
})

export type TResetPasswordInput = z.infer<typeof ResetPasswordInputSchema>;
export type TForgotPasswordInput = z.infer<typeof ForgotPasswordInputSchema>;
